String.prototype.insert = function (this: string, index: number, text: string): string {
	return this.substring(0, index) + text + this.substring(index, this.length);
};

String.prototype.isEmptyString = function (this: string): boolean {
	return this == undefined || this == null || this.length == 0 || this.toString() == '';
};

String.prototype.capitalize = function capitalize<T extends string>(): StringTypes.CapitalizeType<T> {
	return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.words = function words(): string[] {
	return this.trim().split(/\s+/);
};

String.prototype.getNumbers = function getNumbers(separator = ''): string {
	const numbers = this.match(/\d+/g);
	return numbers ? numbers.join(separator) : '';
};

String.prototype.hasNumbers = function hasNumbers(): boolean {
	return /\d/.test(this);
};

export {};
